/* CLEO — Página 3 Academia · cleo-academia.js
   = script.js del ZIP (reveal · hero stagger · smooth scroll · form submit)
   + buscador de ciudad CLEO (Sprint 1) + validación de ciudad antes de enviar
   ─────────────────────────────────────────────────────────────
   Form: cleo-form-academia → webhook Make 741uoo8gsw... (mismo de Sprint 1)
   IDs bl-pg-* y action del form: NO se tocan.
*/
(function () {
  'use strict';

  document.body.classList.add('js-anim');

  /* ---------- REVEAL OBSERVER ---------- */
  var io;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- HERO LETTER STAGGER ---------- */
  var heroTitle = document.getElementById('cleo-hero-title');
  if (heroTitle) {
    var words = heroTitle.querySelectorAll('.word');
    words.forEach(function (word) {
      var t = word.textContent;
      word.innerHTML = '';
      for (var i = 0; i < t.length; i++) {
        var span = document.createElement('span');
        span.className = 'ch';
        span.textContent = t[i];
        span.style.opacity = '0';
        span.style.transform = 'translateY(20px)';
        span.style.transition = 'opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1)';
        span.style.transitionDelay = (i * 0.04) + 's';
        word.appendChild(span);
      }
    });
    setTimeout(function () {
      heroTitle.querySelectorAll('.ch').forEach(function (ch) {
        ch.style.opacity = '1';
        ch.style.transform = 'translateY(0)';
      });
    }, 200);
  }

  /* ---------- BUSCADOR DE CIUDAD CLEO (reemplaza datalist nativo) ---------- */
  function setupCityDropdown() {
    var wrap = document.getElementById('cleo-city-wrap');
    var input = document.getElementById('bl-pg-city-input');
    var arrow = wrap ? wrap.querySelector('.cleo-city-arrow') : null;
    var dd = document.getElementById('cleo-city-dd');
    var search = document.getElementById('cleo-city-search');
    var list = document.getElementById('cleo-city-list');
    var hidden = document.getElementById('bl-pg-city-val');
    if (!wrap || !input || !dd || !list || !hidden) return;

    function openDD() {
      dd.classList.add('is-open');
      wrap.classList.add('is-open');
      search.value = '';
      filterList('');
      setTimeout(function () { search.focus(); }, 40);
    }
    function closeDD() {
      dd.classList.remove('is-open');
      wrap.classList.remove('is-open');
    }
    function filterList(q) {
      var qq = q.toLowerCase().trim();
      var anyVisible = false;
      list.querySelectorAll('li:not(.is-empty)').forEach(function (li) {
        var match = li.textContent.toLowerCase().indexOf(qq) >= 0;
        li.hidden = !match;
        if (match) anyVisible = true;
      });
      var empty = list.querySelector('.is-empty');
      if (!anyVisible) {
        if (!empty) {
          empty = document.createElement('li');
          empty.className = 'is-empty';
          empty.textContent = 'Sin resultados — escribí tu ciudad';
          list.appendChild(empty);
        }
        empty.hidden = false;
      } else if (empty) {
        empty.hidden = true;
      }
    }
    input.addEventListener('click', function () {
      dd.classList.contains('is-open') ? closeDD() : openDD();
    });
    if (arrow) arrow.addEventListener('click', function () {
      dd.classList.contains('is-open') ? closeDD() : openDD();
    });
    search.addEventListener('input', function () { filterList(this.value); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li');
      if (!li || li.classList.contains('is-empty')) return;
      input.value = li.dataset.val;
      hidden.value = li.dataset.val;
      input.style.color = 'var(--cleo-negro)';
      closeDD();
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) closeDD();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dd.classList.contains('is-open')) closeDD();
    });
  }
  setupCityDropdown();

  /* ---------- WHATSAPP — formato suave ---------- */
  var wa = document.getElementById('bl-pg-wa');
  if (wa) {
    wa.addEventListener('input', function () {
      var v = wa.value.replace(/[^\d]/g, '').slice(0, 10);
      if (v.length > 4) v = v.slice(0, 4) + ' ' + v.slice(4);
      if (v.length > 8) v = v.slice(0, 8) + ' ' + v.slice(8);
      wa.value = v;
    });
  }

  /* ---------- FORM SUBMIT ---------- */
  var form = document.getElementById('cleo-form-academia');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Honeypot
      var hp = form.querySelector('input[name="website"]');
      if (hp && hp.value) return;

      // Ciudad obligatoria (buscador custom)
      var cityVal = document.getElementById('bl-pg-city-val');
      var cityInput = document.getElementById('bl-pg-city-input');
      if (cityVal && !cityVal.value) {
        if (cityInput) { cityInput.style.borderColor = '#e0457a'; cityInput.focus(); }
        alert('Por favor elegí tu ciudad de la lista.');
        return;
      }

      var btn = form.querySelector('#bl-pg-btn');
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }

      var data = new FormData(form);
      fetch(form.action, { method: 'POST', body: data, mode: 'no-cors' })
        .then(function () {
          form.parentElement.classList.add('is-sent');
        })
        .catch(function () {
          // no-cors no deja leer la respuesta — igual marcamos enviado
          form.parentElement.classList.add('is-sent');
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = origText; }
        });
    });
  }

  /* ---------- SMOOTH SCROLL ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
